module.exports = __webpack_public_path__ + "img/cross-icon.85b1383b.svg";